<label class="label" [attr.for]="fieldId">{{ label() }}</label>
@if (multiline()) {
  <textarea
    pInputTextarea
    class="search-input observations-field"
    [id]="fieldId"
    readonly
    aria-readonly="true"
    rows="4"
  >{{ displayValue() }}</textarea>
} @else {
  <input
    pInputText
    class="search-input no-select"
    type="text"
    [id]="fieldId"
    readonly
    aria-readonly="true"
    [value]="displayValue()"
  />
}
